import {
  useState,
  useCallback,
  useMemo,
} from 'react';

import {
  getCities,
  createCity,
  updateCity,
  deleteCity,
} from '../../services';

import {
  cityTransform,
} from '../../utils/helpers/transformData';

export function useCity() {
  const [ getting, setGetting ] = useState( false );
  const [ saving, setSaving ] = useState( false );
  const [ isOpenModal, setIsOpenModal ] = useState( false );

  const [ data, setData ] = useState([]);
  const [ city, setCity ] = useState( null );

  const loadCities = useCallback( async () => {
    setGetting( true );

    const { success, message, result } = await getCities();

    if( success ) {
      setData( cityTransform( result ));
    }

    setGetting( false );

    return { success, message };
  }, []);

  const handleOpenModal = useCallback(( data ) => {
    setCity( data );

    setIsOpenModal( true );
  }, []);

  const handleCloseModal = useCallback(() => {
    setCity( null );

    setIsOpenModal( false );
  }, []);

  const handleSave = useCallback( async ( formData ) => {
    setSaving( true );

    const { success, message } = city?._id
      ? city?.function === 'Excluir'
        ? await deleteCity( city._id )
        : await updateCity( city._id, formData )
      : await createCity( formData );

    setSaving( false );

    if( success ) loadCities();

    return { success, message };
  }, [ city ]);

  return useMemo(() => ({
    data,
    city,
    getting,
    saving,
    isOpenModal,
    loadCities,
    handleOpenModal,
    handleCloseModal,
    handleSave,
  }), [
    data,
    city,
    getting,
    saving,
    isOpenModal,
    loadCities,
    handleOpenModal,
    handleCloseModal,
    handleSave,
  ]);
};
